import { render } from "./signup-step-company.vue?vue&type=template&id=09549a4c&ts=true"
import script from "./signup-step-company.vue?vue&type=script&lang=ts"
export * from "./signup-step-company.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__